// @ts-nocheck
// @ts-strict-ignore
export const whitelist = (data, steps) => {
  const fieldsToTrack = steps.reduce((fields, step) => {
    return fields.concat(step.fields.filter((f) => f.trackInput).map((f) => f.name))
  }, [])

  return Object.entries(data).reduce((obj, [key, value]) => {
    return { [key]: fieldsToTrack.includes(key) ? value : 'untracked', ...obj }
  }, {})
}

export const trackFields = (fields) => {
  return fields.filter((field) => field.gtmTrackingEnabled).map((field) => field.name)
}

export const maskPII = (body: Record<string, any>, pii: Array<string>) => {
  try {
    return Object.keys(body).reduce((finalObject, key) => {
      return { ...finalObject, [key]: pii.includes(key) ? 'untracked' : body[key] }
    }, {})
  } catch (e) {}
}
